import { render, staticRenderFns } from "./CreateCourseRelationship.vue?vue&type=template&id=a761f96e&scoped=true&"
import script from "./CreateCourseRelationship.vue?vue&type=script&lang=js&"
export * from "./CreateCourseRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a761f96e",
  null
  
)

export default component.exports